export const SCHOLARSHIP_MANAGEMENT_LIST_PAGE_TEXT = {
  UPDATE_HKPFS_RGC_RESULT: 'Update HKPFS RGC Result',
  FAILED_TO_UPDATE_HKPFS_RGC_RESULT: 'Failed to update the HKPFS RGC result.',
  SUCCEEDED_IN__UPDATEING_HKPFS_RGC_RESULT:
    'Succeeded in updating the HKPFS RGC result.',
  FAILED_UPDATE_LIST: 'Failed Update List',
  CLOSE: 'Close',
  APPLICATION_NO: 'Application No',
  NAME: 'Name',
  HKPFS_REFERENCE_NUMBER: 'HKPFS Reference Number',
  UPDATE_STATUS: 'Update Status',
  ERROR_MESSAGE: 'Error Message',
  NA: 'N/A',
};
